import RocketIcon from '../../../../assets/svg/utils/rocket/rocket-highlighted.svg';
import USDTIcon from '../../../../assets/svg/utils/usdt.svg';
import { TChestHistoryResponse, TChestReward } from '../../../../types';
import { getChestRewardIcon } from '../../utils/getChestRewardIcon';

type TChestRewardCardProps = {
    chestReward: TChestReward
    multiplier: TChestHistoryResponse['multiplier'] | undefined
}

function ChestRewardCard({ chestReward, multiplier }: TChestRewardCardProps) {
  const icon = getChestRewardIcon(chestReward.variant);
  return (
    <div
      className={`
        min-w-[154px] aspect-[1/1]
        flex flex-col justify-center items-center py-[9px]
      `}
    >
      <div className="w-full flex justify-end px-2">
        {/* eslint-disable-next-line eqeqeq */}
        {(multiplier && multiplier != 1)
        && (
        <div className="top-0 right-0 chest-multiplier px-2 w-fit">
          x
          {multiplier}
        </div>
        )}
      </div>
      <div className="flex items-center justify-center h-[116px]">
        <img src={icon} alt="reward" className="h-[120px]" />
      </div>
      <div className="flex gap-2 text-sm">
        {!!chestReward.rewards.usdt
        && (
        <div className="flex items-center">
          <img src={USDTIcon} className="w-4" alt="usdt-icon" />
          {chestReward.rewards.usdt}
          {' '}
          USDT
        </div>
        )}
        {!!chestReward.rewards.rocketCoins
        && (
        <div className="flex items-center">
          <img src={RocketIcon} className="w-[18px]" alt="rocket-icon" />
          {chestReward.rewards.rocketCoins}
        </div>
        )}
      </div>
    </div>
  );
}

export default ChestRewardCard;
